import { ActionButton, BaseTable, Loading } from "components"
import type { SelectedState } from "pages/Purchase/Register/types/Location"
import { convertNumber, useApi } from "utils"
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils"
import { SelectedStateRefetch } from "pages/Purchase/Register/types/ByCard"
import { DataList } from "../types"
import { ApproveAction } from "pages/Purchase/Transaction/ApproveReceivedRejected/components"
import toast from "react-hot-toast"
import { PERMISION } from "security"

interface TableSectionProps {
  data: DataList[]
  exportDateFormat?: string
  isLoading?: boolean
  selected?: SelectedState
  refetch?: (data: SelectedStateRefetch) => void
}

export const TableSection = ({ data, isLoading, refetch, selected }: TableSectionProps) => {
  const api = useApi()
  const convertType = (data: number) => {
    if (data === 1) {
      return "RECEIVED REJECTED ITEM"
    }
    if (data === 2) {
      return "RECEIVED REJECTED MONEY"
    }
    if (data === 3) {
      return "RECEIVED REJECTED ADJUSTMENT"
    }
    return "-"
  }
  const approvalChecked = (data: number) => {
    if (data === 1) {
      return "PENDING"
    }
    if (data === 2) {
      return "REVISED"
    }
    if (data === 3) {
      return "REJECTED"
    }
    if (data === 4) {
      return "APPROVED"
    }
    return "-"
  }
  const getRejectedDifference = (qty_received: number, qty_rejected: number): number => {
    return (qty_rejected || 0) - (qty_received || 0);
  }

  return (
    <div className="overflow-x-auto max-h-[calc(100vh-570px)]">
      <BaseTable className="border-transparent">
        <thead className="top-0 z-1 !bg-black !text-white">
          <tr className="uppercase">
            <th>No</th>
            <th>RECEIVED REJECTED ID#</th>
            <th>REF REJECTED ITEM ID#</th>
            <th>REF BILL ID#</th>
            <th>DATE</th>
            <th>TYPE</th>
            <th>LOCATION</th>
            <th>VENDOR</th>
            <th>STATUS APPROVAL</th>
            <th>QTY REJECRED</th>
            <th>QTY RECEIVED</th>
            <th>BACK REJECTED</th>
            <th>SUBTOTAL</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          {!data.length || isLoading ? (
            <tr>
              <td colSpan={15} className="text-center">
                <Loading
                  loading={isLoading}
                  errorText={isLoading ? "" : "No data available"}
                />
              </td>
            </tr>
          ) : (
            data.map((val, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{val?.trx_code ?? "-"}</td>
                <td>{val?.ref_rejected_item ?? "-"}</td>
                <td>{val?.ref_bill_id ?? "-"}</td>
                <td>{val?.transaction_date ? convertDate(val?.transaction_date) : "-"}</td>
                <td>{val?.type_received ? convertType(val?.type_received) : "-"}</td>
                <td>{val?.location_name ?? "-"}</td>
                <td>{val?.vendor_name ?? "-"}</td>
                <td>{val?.approve_status ? approvalChecked(val?.approve_status) : "-"}</td>
                <td className="text-center">{val?.qty_rejected ? convertNumber(Number(val?.qty_rejected))?.intoNormalAmount : "-"}</td>
                <td className="text-center">{val?.qty_received ? convertNumber(Number(val?.qty_received))?.intoNormalAmount : "-"}</td>
                <td className="text-center">{getRejectedDifference(Number(val?.qty_received), Number(val?.qty_rejected))}</td>
                <td className="text-right">{val?.subtotal ? convertNumber(Number(val?.subtotal))?.intoCurrency : "-"}</td>
                <td>
                  <section className="flex items-center gap-2">
                    <ApproveAction isDetail data={val} refetch={() => {}} />
                    {val?.approve_status === 1 && <ActionButton.Delete
                      permission={PERMISION.PURCHASES.REGISTER.RECEIVED_REJECTED.DELETE}
                      onClick={() => {
                        if (!val?.reject_id) return;

                        toast.promise(
                          api.delete(`/proreject/delete_received_reject?received_reject_id=${val.received_reject_id}`).then(() => {
                            const filteredSelected: Partial<SelectedState> = {}

                            ;(
                              Object.keys(selected!) as Array<
                                keyof SelectedState
                              >
                            ).forEach((key) => {
                              if (selected![key]) {
                                filteredSelected[key] = selected![key]
                              }
                            })
                            if (refetch) refetch(filteredSelected);
                          }),
                          {
                            loading: 'Deleting...',
                            success: 'Reject deleted successfully!',
                            error: 'Failed to delete reject.',
                          }
                        );
                      }}
                    />}
                  </section>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </BaseTable>
    </div>
  )
}
